<template>
  <div class="detail">
    <div class="detail_content">
      <!-- 顶部 -->
      <div class="detail_top">
        <div class="top_title">
          报警信息
          <div class="status-tag tag-primary" v-if="content.disposeStage == 1">待处理</div>
          <div class="status-tag tag-primary" v-if="content.disposeStage == 2">待验收</div>
          <div class="status-tag tag-success" v-if="content.disposeStage == 3">已完结</div>
        </div>

        <div class="split_line"></div>
        <!-- 报警图片部分 -->
        <div class="top_img_video">
          <img :src="content.signAvatar || (content.type == 10 && qiling) || (content.type == 9 && fire)" @click="previewImg(content.signAvatar || (content.type == 10 && qiling) || (content.type == 9 && fire))" v-if="!isShowBackVideo" alt="" />

          <!-- 欺凌关键词 -->
          <div class="alarm_keyword" v-if="!isShowBackVideo && content.type == 10 && content.parameter">触发关键词：{{ JSON.parse(content.parameter).keywords }}</div>

          <!-- 播放器部分 -->
          <div id="mse1" class="video_div" v-if="isShowBackVideo"></div>
        </div>

        <!-- 倒计时 -->
        <div class="top_Countdown" v-if="sdk && type && isShowCountDown">
          <img src="@/assets/countdown.png" alt="" />
          <van-count-down :time="time" format="mm:ss" @finish="countDownFinish" />
        </div>

        <div class="top_Countdown" v-if="!type || !isShowCountDown"></div>

        <!-- 回放/喊话/倾听/语音对讲 -->
        <div class="top_type" v-if="showBackBtn || sdk">
          <div v-if="showBackBtn && content.type != 2 && content.type != 10" :class="isShowBackVideo ? 'top_type_item item_active' : 'top_type_item'" @click="handleClickBackplay">
            <img v-if="!isShowBackVideo" src="@/assets/backplay.png" />
            <img v-if="isShowBackVideo" src="@/assets/backplay_active.png" />
            <span style="margin-left: 0.33rem;">{{ isShowBackVideo ? '关闭回放' : '回放' }}</span>
          </div>

          <div v-if="sdk && content.talkBackDeviceId" :class="type == 2 ? 'top_type_item item_active' : 'top_type_item'" @click="handleClickSoundColumnLink(2)">
            <img v-if="type != 2" src="@/assets/hanhua.png" />
            <img v-if="type == 2" src="@/assets/hanhua_active.png" />
            <span>现场喊话</span>
          </div>
          <!--  <div v-if="sdk && content.talkBackDeviceId" :class="type == 3 ? 'top_type_item item_active' : 'top_type_item'" @click="handleClickSoundColumnLink(3)">
            <img v-if="type != 3" src="@/assets/qingting.png" />
            <img v-if="type == 3" src="@/assets/qingting_active.png" />
            <span>现场倾听</span>
          </div>-->
          <div v-if="sdk && content.talkBackDeviceId" :class="type == 4 ? 'top_type_item item_active' : 'top_type_item'" @click="handleClickSoundColumnLink(4)">
            <img v-if="type != 4" src="@/assets/duijiang.png" />
            <img v-if="type == 4" src="@/assets/duijiang_active.png" />
            <span>现场通话</span>
          </div>
        </div>
        <!-- 报警位置时间和描述 -->
        <div class="top_info">
          <div class="top_info_item">
            <span class="item_label">报警类型</span>
            <span class="item_info">{{ content.typeName }}</span>
          </div>
          <div class="top_info_item">
            <span class="item_label">报警等级</span>
            <span class="item_info">{{ ['', '一级（重大风险）', '二级（较大风险）', '三级（一般风险）', '四级（低风险）'][content.level] }}</span>
          </div>
          <div class="top_info_item">
            <span class="item_label">报警地点</span>
            <span class="item_info">{{ content.location }}</span>
          </div>
          <div class="top_info_item">
            <span class="item_label">报警时间</span>
            <span class="item_info">{{ content.warningBeginTime }}</span>
          </div>
          <div class="top_info_item">
            <span class="item_label">报警描述</span>
            <span class="item_info">{{ content.warningInfo }}</span>
          </div>

          <div class="top_info_item" v-if="content.audioUrl != null">
            <audio class="success" style="height: 2rem;width: 100%;" :src="content.audioUrl" controls>
              您的浏览器不支持 audio 标签
            </audio>
          </div>
        </div>
      </div>

      <!-- 中部触发人 -->
      <div class="detail_center" v-if="content.disposeStage == 1 && pageType == 'dispose'">
        <div class="center_title">
          <span>
            触发人
          </span>
          <div class="center_add" @click="openAddTriggerPerson">
            <img src="@/assets/addTriggerPerson.png" alt="" />
            新增
          </div>
        </div>
        <div class="split_line"></div>
        <div class="center_list">
          <div class="center_item" v-for="item in content.warningUsers">
            <img class="item_avatar" @click="previewImg(item.avatar)" :src="item.avatar" alt="" />
            <div class="item_info">
              <span>{{ item.userName }}{{ item.orgName ? ' - ' + item.orgName : ' - ' + getPersonType(item.personType) }}</span>
              <span class="item_type">{{ item.personBehaviorType == 1 ? '报警触发人' : item.personBehaviorType == 2 ? '施暴人' : '受害人' }}</span>
            </div>
            <img class="item_del" src="@/assets/triggerDel.png" @click="delTriggerPerson(item)" alt="" />
          </div>
        </div>
      </div>
      <template v-else>
        <div class="detail_center" v-if="content.warningUsers && content.warningUsers.length > 0">
          <div class="center_title">
            <span>
              触发人
            </span>
          </div>
          <div class="split_line"></div>
          <div class="center_list">
            <div class="center_item" v-for="item in content.warningUsers">
              <img class="item_avatar" @click="previewImg(item.avatar)" :src="item.avatar" alt="" />
              <div class="item_info">
                <span>{{ item.userName }}{{ item.orgName ? ' - ' + item.orgName : '' }}{{ item.orgName ? '' : ' - ' + getPersonType(item.personType) }}</span>
                <span class="item_type">{{ item.personBehaviorType == 1 ? '报警触发人' : item.personBehaviorType == 2 ? '施暴人' : '受害人' }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- 底部预报警处理 -->
      <!-- <div class="detail_bottom">
        <div class="bottom_title">预报警处理</div>
        <div class="bottom_info">
          <span class="info_label">处 理 人 ：</span>
          <span class="info_detail">{{ handlerName }}</span>
        </div>
        <div class="bottom_info">
          <span class="info_label">处理时间：</span>
          <span class="info_detail">{{ getNowDate(content.warningEndTime) }}</span>
        </div>
        <div class="bottom_info">
          <span class="info_label">处理分类：</span>

          <div class="info_btns" v-if="content.warningState == 0">
            <div :class="currentHandleType == 1 ? 'btns_item btn_border' : 'btns_item'" @click="handleCurrentAlarmType(1)" style="background-color: #F16F6D;">
              <span>真实</span>
            </div>

            <div :class="currentHandleType == 2 ? 'btns_item btn_border' : 'btns_item'" @click="handleCurrentAlarmType(2)" style="background-color: #DEA249;">
              <span>巡检</span>
            </div>

            <div :class="currentHandleType == 3 ? 'btns_item btn_border' : 'btns_item'" @click="handleCurrentAlarmType(3)" style="background-color: #8F939E;">
              <span>误报</span>
            </div>
          </div>
          <span class="info_detail" v-if="content.warningState == 2">{{ ['', '真实', '巡检', '误报'][content.handleType] }}</span>
        </div>
        <div class="bottom_info bottom_test">
          <span class="info_label">处理情况：</span>
          <span class="info_detail" v-if="content.warningState == 2">{{ content.warningEndInfo || '无' }}</span>
          <div class="info_textArea" v-if="content.warningState == 0">
            <van-field rows="2" v-model="reason" autosize type="textarea" placeholder="请输入处理情况" show-word-limit />
          </div>
        </div>
      </div> -->
      <!-- 提交按钮 -->
      <!-- <div class="access_btn_con" v-if="content.warningState == 0">
        <van-button class="access_btn" @click="handleAccess" color="#37A5DA">提交</van-button>
      </div> -->
      <div class="detail_center" v-if="content.solveLogVMs && content.solveLogVMs.length > 0">
        <div class="center_title">
          处理流程
        </div>
        <div class="split_line"></div>
        <div>
          <div class="process-item" v-for="(item, index) in content.solveLogVMs" :key="index">
            <div class="item-top">
              <div class="top-left">
                <div class="dot-top"></div>
                <div class="dot"></div>
                <div class="dot-bottom"></div>
              </div>
              <div class="top-right">
                <div class="title-left">
                  <template v-if="item.processType == 1">
                    <div class="process-type type-primary">发生</div>
                    <div class="operator">
                      <template>
                        <span>{{ content.typeName }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="item.processType == 3">
                    <div class="process-type type-primary">处理</div>
                    <div class="operator" v-if="!!item.handlePersonDept || !!item.handlePersonName">
                      <template>
                        <span>{{ item.handlePersonDept ? item.handlePersonName + ' - ' + item.handlePersonDept : item.handlePersonName }}</span>
                      </template>
                    </div>
                  </template>
                  <template v-if="item.processType == 4">
                    <div class="process-type type-primary">验收</div>
                    <div class="operator" v-if="!!item.handlePersonDept || !!item.handlePersonName">
                      <template>
                        <span>{{ item.handlePersonDept ? item.handlePersonName + ' - ' + item.handlePersonDept : item.handlePersonName }}</span>
                      </template>
                    </div>
                  </template>
                </div>
                <div class="title-right">
                  <!-- <template v-if="item.processType == 1"> -->
                  <div class="operator-timer" v-if="item.createdTime">
                    {{ formData(item.createdTime) }}
                  </div>
                  <!-- </template> -->
                </div>
              </div>
            </div>
            <div class="item-bottom">
              <div class="bottom-left">
                <div class="bottom-line"></div>
              </div>
              <div class="bottom-right">
                <div class="process-content" v-if="item.processType == 3">
                  <div class="process-form-item" style="align-items: center">
                    <div class="process-form-label">处理结果</div>
                    <div class="process-form-content">
                      <div class="result-tag zhenshi active" v-if="item.examineResult == 1">真 实</div>
                      <div class="result-tag xunjian active" v-if="item.examineResult == 2">巡 检</div>
                      <div class="result-tag wubao active" v-if="item.examineResult == 3">误 报</div>
                    </div>
                  </div>
                  <div class="process-form-item">
                    <div class="process-form-label">处理情况</div>
                    <div class="process-form-content">
                      {{ item.handleOpinion }}
                    </div>
                  </div>
                  <div class="process-form-item">
                    <div class="process-form-label">处理照片</div>
                    <div class="process-form-content">
                      <div style="display: flex; flex-wrap: wrap; gap:0.38rem" v-if="item.disposeImg">
                        <div v-for="(photo, photoIndex) in item.disposeImg" :key="photoIndex" class="image-item">
                          <!-- <AjImage :src="photo" :index="photoIndex" :imageList="item.disposeImg || []"></AjImage> -->
                          <img class="item_avatar" @click="previewImg2(photoIndex, item.disposeImg)" :src="photo.tempFilePath" alt="" style="object-fit: cover;height: 100%;width: 100%;" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="process-content" v-if="item.processType == 4">
                  <div class="process-form-item">
                    <div class="process-form-label">验收情况</div>
                    <div class="process-form-content">
                      {{ item.examineResult == 1 ? '通过' : '驳回' }}
                    </div>
                  </div>
                  <div class="process-form-item">
                    <div class="process-form-label">验收意见</div>
                    <div class="process-form-content">
                      {{ item.handleOpinion }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail_operation" v-if="(content.disposeStage == 1 && pageType == 'dispose') || (content.disposeStage == 2 && pageType == 'acceptance')">
      <template v-if="content.disposeStage == 1 && pageType == 'dispose'">
        <div class="bottom-button button-danger" @click="handleZhenShi()">真 实</div>
        <div class="bottom-button button-warning" @click="handleXunJian()">巡 检</div>
        <div class="bottom-button button-info" @click="handleWuBao()">误 报</div>
      </template>
      <!-- 验收 -->
      <template v-if="content.disposeStage == 2 && pageType == 'acceptance'">
        <div class="bottom-button button-danger" @click="handleYanShou(2)">驳 回</div>
        <div class="bottom-button button-primary" @click="handleYanShou(1)">通 过</div>
      </template>
    </div>

    <audio id="html_audio_remote" class="audio" autoPlay></audio>

    <van-popup class="popup" v-model="showTriggerPopup" round position="bottom">
      <!-- 标题部分 -->
      <div class="popup_title">
        <div></div>
        <div class="title_text">
          添加触发人
        </div>
        <van-icon name="cross" @click="handleClickCloseTriggerPopup" />
      </div>

      <div class="popup_form">
        <div class="form_name">
          <span class="name_text">人员姓名：</span>
          <div @click="showUserPop = true" style="flex: 1;">
            <el-input v-model="currentPersonShow" size="small" readonly placeholder="请选择人员姓名"></el-input>
          </div>
          <!-- <el-input v-model="currentPersonShow" readonly size="small"></el-input> -->
          <!-- 获取报警触发人  -->
          <!-- <el-select filterable class="name_select" remote :popper-append-to-body="false" :remote-method="searchOptions" clearable size="small" v-model="currentPerson" placeholder="请输入人员姓名">
            <el-option v-for="item in triggerPersonList" :key="item.id" :label="`${item.name} ${item.deptName ? ' - ' + item.deptName : ''}${item.personType ? ' - ' + { 11: '学生', 3: '陌生人', 12: '家长', 13: '教职工', 14: '社区人员', 5: '黑名单', 2: '访客' }[item.personType] : ''}`" :value="item.id"></el-option>
          </el-select> -->
        </div>

        <div class="form_kind">
          <span class="name_text">行为分类：</span>
          <div @click="showFenleiPop = true" style="flex: 1;">
            <el-input v-model="currentBehaviorKindShow" size="small" readonly placeholder="请选择行为分类"></el-input>
          </div>

          <!-- <el-select class="name_select" :popper-append-to-body="false" clearable size="small" v-model="currentBehaviorKind" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select> -->
        </div>
      </div>
      <div class="popup_btn">
        <van-button style="width: 48%;" round type="default" @click="handleClickCloseTriggerPopup">取消</van-button>
        <van-button style="width: 48%;" round type="info" @click="addTriggerPerson">确认</van-button>
      </div>
      <!-- 按钮部分 -->
    </van-popup>
    <van-popup class="popup" v-model="showUserPop" round position="bottom">
      <!-- 标题部分 -->
      <div class="popup_title">
        <div></div>
        <div class="title_text">
          选择人员
        </div>
        <van-icon name="cross" @click="showUserPop = false" />
      </div>
      <el-input v-model="filterUser" placeholder="请输入人员姓名" size="small" @input="filterUserChange"></el-input>
      <div class="pop-select-list" style="height: 20rem;">
        <div class="pop-select-list-inner">
          <div class="pop-select-item" v-for="item in triggerPersonList" :key="item.id" @click="selectUser(item)">
            {{ `${item.name}` }}
            {{ item.className || item.deptName ? ' - ' + (item.className || item.deptName) : ' - ' + getPersonType(item.personType) }}
          </div>
          <van-empty v-if="triggerPersonList.length == 0" description="暂无数据" />
        </div>
      </div>
    </van-popup>
    <van-popup class="popup" v-model="showFenleiPop" round position="bottom">
      <!-- 标题部分 -->
      <div class="popup_title">
        <div></div>
        <div class="title_text">
          选择行为分类
        </div>
        <van-icon name="cross" @click="showFenleiPop = false" />
      </div>
      <div class="pop-select-list">
        <div class="pop-select-list-inner">
          <div class="pop-select-item" v-for="item in options" :key="item.value" @click="selectFenlei(item)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 按钮部分 -->
    </van-popup>
    <AlarmDispose ref="disposePopRef" :handlerId="handlerId" :handlerName="handlerName" :schoolId="content.schoolId" :token="token" @refresh="refresh()"></AlarmDispose>
    <AlarmAccept ref="acceptPopRef" :handlerId="handlerId" :handlerName="handlerName" :schoolId="content.schoolId" :token="token" @refresh="refresh()"></AlarmAccept>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Player from 'xgplayer';
import 'xgplayer/dist/index.min.css';
import { ImagePreview, Empty } from 'vant';
import AlarmDispose from './AlarmDispose.vue';
import AlarmAccept from './AlarmAccept.vue';
import * as constant from '@/constant';
import wx from 'weixin-js-sdk'; // 引入微信SDK
let timer = null;
export default {
  components: {
    AlarmDispose,
    AlarmAccept
  },
  data() {
    return {
      filterUser: '',
      showUserPop: false,
      showFenleiPop: false,
      sdk: null, // 狮子王sdk
      id: '', // 报警事件Id
      content: '', // 报警事件详情
      // 学校Id
      schoolId: '',
      token: '', // 获取到传递的小程序的token
      handlerId: '', // 处理人Id
      type: '',
      handlerName: '', // 处理人姓名
      status: '', // 当前报警事件状态
      parameter: '', // 宿舍归寝等相关参数

      // 选中回放 / 喊话 / 倾听 / 语音对讲
      type: '', //  1 回放 2. 喊话 3 倾听 4 语音对讲
      // 是否显示回放按钮
      showBackBtn: false,

      // 是否显示回放视频
      isShowBackVideo: false,

      // 当前搜索的触发人的列表信息
      triggerPersonList: [],
      // 展示触发人
      currentPersonShow: '',
      // 当前选中的触发人
      currentPerson: '',
      // 当前选中的行为分类
      currentBehaviorKind: '',

      // 处理情况
      reason: '',

      // 获取当前学校的狮子王id
      appId: '',
      // 获取当前学校的狮子王code
      appCode: '',
      // 当前学校的账号
      account: '',
      // 当前喊话 / 对讲 / 倾听 id
      TaskCode: '',

      // 当前选择的处理分类
      currentHandleType: '',
      // 倒计时时间
      time: 3 * 60 * 1000,

      // 当前是否显示倒计时组件
      isShowCountDown: false,

      showTriggerPopup: false,

      // 当前报警处置人在当前学校中的身份信息
      nowAlarmPersonInfo: '',

      qiling: require('@/assets/qiling.webp'),
      fire: require('@/assets/fire_alarm.webp'),

      options: [
        {
          value: 1,
          label: '报警触发人'
        },
        {
          value: 2,
          label: '施暴人'
        },
        {
          value: 3,
          label: '受害人'
        }
      ],
      pageType: 'detail'
    };
  },
  computed: {
    currentBehaviorKindShow() {
      if (this.currentBehaviorKind) {
        return { 1: '报警触发人', 2: '施暴人', 3: '受害人' }[this.currentBehaviorKind];
      } else {
        return null;
      }
    }
  },

  mounted() {},
  async created() {
    let obj = this.$route.query;

    this.id = obj.id; // 报警事件Id
    this.token = obj.token; // this.getParams('token') // token
    this.handlerId = obj.handlerId; // this.getParams('handlerId') // 处理人Id
    this.handlerName = obj.handlerName; // decodeURI(_this.getParams('handlerName'))
    this.status = obj.type; //  this.getParams('type')
    this.pageType = obj.pageType;
    // 获取当前的报警详情
    await this.getAlarmDetail();
    // 获取到人员信息
    await this.getPersonIdentity();
    // 获取当前学校信息
    this.getSchoolInfo();
  },
  methods: {
    filterUserChange() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(() => {
        this.searchOptions(this.filterUser);
      }, 500);
    },
    selectFenlei(item) {
      this.currentBehaviorKind = item.value;
      this.showFenleiPop = false;
    },
    selectUser(item) {
      this.currentPerson = item.id;
      this.currentPersonShow = `${item.name} ${item.className || item.deptName ? ' - ' + (item.className || item.deptName) : ' - ' + this.getPersonType(item.personType)}`;
      this.showUserPop = false;
    },
    formData(time, format) {
      return moment(time).format(format || 'YYYY-MM-DD HH:mm:ss');
    },
    // 真实
    handleZhenShi() {
      this.$refs.disposePopRef.open([this.content.id], 1);
    },
    // 巡检
    handleXunJian() {
      this.$refs.disposePopRef.open([this.content.id], 2);
    },
    // 误报
    handleWuBao() {
      this.$refs.disposePopRef.open([this.content.id], 3);
    },
    // 验收
    handleYanShou(examineResult) {
      this.$refs.acceptPopRef.open([this.content.id], examineResult);
    },
    // 获取当前时间
    getNowDate(date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD HH:mm');
      } else {
        return moment().format('YYYY-MM-DD HH:mm');
      }
    },

    // 选择处理情况
    handleCurrentAlarmType(type) {
      if (this.currentHandleType == type) {
        this.currentHandleType = '';
      } else {
        this.currentHandleType = type;
      }
    },

    // 点击关闭触发人添加弹窗
    handleClickCloseTriggerPopup() {
      this.showTriggerPopup = false;
      this.triggerPersonList = [];
      this.filterUser = '';
      this.currentPerson = '';
      this.currentPersonShow = '';
      this.currentBehaviorKind = '';
    },

    // 获取当前人的身份信息
    async getPersonIdentity() {
      let _this = this;

      let params = {
        schoolId: this.schoolId,
        userId: this.handlerId
      };

      // axios.get('http://192.168.10.135:8888/auth/api/schoolUser/findSystemUserByTpdUserIdAndSchoolId', {
      let res = await axios.get(constant.baseUrl + 'auth/api/schoolUser/findSystemUserByTpdUserIdAndSchoolId', {
        params,
        headers: {
          Authorization: _this.token
        }
      });
      let data = res.data;
      if (data.code == 200) {
        this.$store.commit('setUserInfo', data.data);
        if (data.data) {
          _this.nowAlarmPersonInfo = data.data;
        }
      } else if (data.code == 401) {
        _this.$toast('登录过期，请重新登录');
        setTimeout(() => {
          wx.miniProgram.navigateTo({ url: '/pages/login/login' });
        }, 1500);
      }
    },
    refresh() {
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        if (this.fromType === 'gzh') {
          // 公众号处理完毕则为详情
          this.getAlarmDetail();
        } else {
          wx.miniProgram.navigateTo({ url: '/pages2/alarmHandling/index' });
        }
      } else {
        this.getAlarmDetail();
      }
    },
    // 获取当前报警事件详情
    async getAlarmDetail() {
      let res = await this.$https.getAlarmDetailByIdWithoutToken({
        id: this.id
      });

      if (res.code == 200) {
        this.content = res.data;
        this.schoolId = res.data.schoolId;
        this.content.warningBeginTime = moment(this.content.warningBeginTime).format('YYYY-MM-DD HH:mm:ss');
        // this.content.warningEndTime = moment(this.content.warningEndTime).format(
        //   'YYYY-MM-DD HH:mm')

        if (this.content.playbackUrl) {
          // 判断是否为rtsp格式
          let str = this.content.playbackUrl.substring(0, 4);
          if (str != 'rtsp') {
            this.showBackBtn = true;
          }
        }
        if (this.content.disposeStage === null) {
          this.content.disposeStage = 1;
        }
      } else {
        this.content = '';
      }
    },

    // 获取当前学校信息+
    getSchoolInfo() {
      let _this = this;
      axios
        .get(constant.baseUrl + 'student-consumer/api/school/getSchoolInfo', {
          // 线上地址
          // axios.get('http://192.168.10.135:8888/student-consumer/api/school/getSchoolInfo', {
          params: {
            id: this.schoolId
          },
          headers: {
            Authorization: _this.token
          }
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            this.appId = data.data.lionAppId;
            this.appCode = data.data.lionAppCode;
            this.account = data.data.adminAccount;
            // 判断是否启动sdk
            if (this.content.talkBackDeviceId && this.appId && this.appCode) {
              this.firingSDK();
            }
          } else if (data.code == 401) {
            _this.$toast('登录过期，请重新登录');
            setTimeout(() => {
              wx.miniProgram.navigateTo({ url: '/pages/login/login' });
            }, 1500);
          }
        });
    },

    // 初始化播放器
    initPlayer() {
      let _this = this;
      let player = new Player({
        id: 'mse1',
        url: _this.content.playbackUrl,
        poster: _this.content.signAvatar,
        videoInit: true, // 显示首帧
        width: '100%',
        height: '100%',

        autoplay: true,
        cors: true, // 跨域
        playsinline: true
      });
    },

    // 提交报警事件处理
    async handleAccess() {
      // 判断处理分类
      if (!this.currentHandleType) {
        this.$toast('请选择处理分类');
        return;
      }

      let res = await this.$https.handleAlarmEvent({
        id: this.id,
        handlerId: this.handlerId,
        reason: this.reason,
        handleType: this.currentHandleType,
        handleTime: moment(this.getNowDate()).format('YYYY-MM-DD HH:mm:ss')
      });

      if (res.code == 200) {
        this.$toast('处理成功');
        wx.miniProgram.navigateTo({ url: '/pages/login/login' });
      } else {
        this.$toast('处理失败');
      }
    },

    searchOptions(query) {
      let _this = this;
      if (query !== '') {
        axios
          .post(
            constant.baseUrl + 'student-consumer/api/user/getUserListByName', //线上环境
            // axios.post('http://192.168.10.135:8888/student-consumer/api/user/getUserListByName',

            {
              name: query,
              pageNum: 1,
              pageSize: 100,
              schoolId: _this.schoolId
            },
            {
              headers: {
                Authorization: _this.token
              }
            }
          )
          .then(res => {
            let data = res.data;
            if (data.code == 200) {
              this.triggerPersonList = data.data.list;
            } else if (data.code == 401) {
              _this.$toast('登录过期，请重新登录');
              setTimeout(() => {
                wx.miniProgram.navigateTo({ url: '/pages/login/login' });
              }, 1500);
            }
          });
      } else {
        this.triggerPersonList = [];
      }
    },

    // 获取到传递的参数
    getParams(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      return r ? unescape(r[2]) : '';
    },

    // 点击回放
    handleClickBackplay() {
      this.isShowBackVideo = !this.isShowBackVideo;
      if (this.isShowBackVideo) {
        // 初始化播放器
        this.$nextTick(() => {
          this.initPlayer();
        });
      }
    },

    // 获取触发人的人员类型
    getPersonType(personType) {
      return {
        11: '学生',
        3: '陌生人',
        12: '家长',
        13: '教职工',
        14: '社区人员',
        5: '黑名单',
        2: '访客'
      }[personType];
    },

    // 启动sdk
    firingSDK() {
      let _this = this;
      let obj = new SOS.SDK({
        AppId: _this.appId,
        AppCode: _this.appCode,
        Account: _this.nowAlarmPersonInfo ? _this.nowAlarmPersonInfo.account : _this.account,
        LogLevel: 'debug',
        LogFun: this.sdkLog,
        ServerAddr: 'norsos.lionking110.com'
      });
      obj
        .init()
        .then(() => {
          _this.sdk = obj;
        })
        .catch(error => {});
    },

    // 点击喊话 / 倾听 / 语音对讲
    handleClickSoundColumnLink(type) {
      // 判断当前的type值
      let _this = this;

      if (!this.type) {
        // 启动相应的功能
        let obj = {
          '2': () => {
            _this.shoutStart();
          },
          '3': () => {
            _this.listenForStart();
          },
          '4': () => {
            _this.voiceIntercomStart();
          }
        };
        obj[type]();
      } else if (type == this.type) {
        // 关闭对应的功能
        let obj = {
          '2': async () => {
            await _this.shoutEnd();
          },
          '3': async () => {
            await _this.listenForEnd();
          },
          '4': async () => {
            await _this.voiceIntercomEnd();
          }
        };
        obj[type]();
      } else {
        // 关闭当前的功能
        let obj1 = {
          '2': async () => {
            await _this.shoutEnd();
          },
          '3': async () => {
            await _this.listenForEnd();
          },
          '4': async () => {
            await _this.voiceIntercomEnd();
          }
        };
        // 执行点击功能
        let obj2 = {
          '2': () => {
            _this.shoutStart();
          },
          '3': () => {
            _this.listenForStart();
          },
          '4': () => {
            _this.voiceIntercomStart();
          }
        };
        obj1[_this.type]();
        obj2[type]();
      }
    },

    // 开启喊话
    async shoutStart() {
      this.type = 2;
      this.$toast('现场喊话启动中！');
      await this.closeAllTask();
      this.sdk
        .microphoneMutilBoradcastStart({
          DeviceIds: [Number(this.content.talkBackDeviceId)]
        })
        .then(res => {
          this.TaskCode = res.TaskCode;
          this.isShowCountDown = true; // 展示倒计时
          this.$toast('现场喊话启动成功');
        })
        .catch(e => {
          this.type = '';

          if (e.code == 3551) {
            this.$toast('设备忙线中');
          } else if (e.code == 2006) {
            this.$toast('设备不在线');
          } else {
            this.$toast('现场喊话启动失败');
          }
        });
    },

    // 关闭喊话
    async shoutEnd() {
      this.type = '';
      this.$toast('现场喊话关闭中！');
      try {
        let rsp = await this.sdk.microphoneMutilBoradcastStop({
          TaskCode: this.TaskCode
        });

        this.TaskCode = '';
        // 关闭倒计时
        this.isShowCountDown = false;
        this.$toast('现场喊话关闭成功');
      } catch (error) {
        this.$toast('现场喊话关闭失败');
      }
    },

    // 开启倾听
    async listenForStart() {
      this.type = 3;

      await this.closeAllTask();
      this.$toast('现场倾听启动中！');
      let disconnectedCallback = () => {
        this.$toast('已退出现场倾听！');
      };
      let stopCallback = () => {
        this.$toast('现场倾听结束');
      };

      this.sdk
        .audioListenStart({
          DeviceId: Number(this.content.talkBackDeviceId),
          AudioDomId: 'html_audio_remote',
          Force: false,
          OnDisconnected: disconnectedCallback,
          OnStop: stopCallback
        })
        .then(ret => {
          this.$toast('现场倾听启动成功');
          this.TaskCode = ret.TaskCode;
          this.isShowCountDown = true;
        })
        .catch(e => {
          this.type = '';
          if (e.code == 2006) {
            this.$toast(e.message);
          } else if (e.code == 3551) {
            this.$toast('设备忙线中');
          } else if (e.code == 2005) {
            this.$toast('现场倾听失败，设备不存在');
          } else {
            this.$toast('现场倾听启动失败');
          }
        });
    },

    // 关闭倾听
    async listenForEnd() {
      this.type = '';
      this.$toast('现场倾听关闭中！');
      try {
        let rsp = await this.sdk.audioListenStop({
          TaskCode: this.TaskCode
        });
        this.TaskCode = '';
        this.isShowCountDown = false;
        this.$toast('现场倾听关闭成功！');
      } catch (error) {
        this.$toast('现场倾听关闭失败');
      }
    },

    // 语音对讲
    async voiceIntercomStart() {
      this.type = 4;
      await this.closeAllTask();
      this.$toast('现场通话启动中');
      let stopCallback = () => {
        this.$toast('现场通话结束');
      };
      let disconnectedCallback = SipNum => {
        this.$toast('已退出现场通话');
      };
      this.sdk
        .audioSpeakStart({
          DeviceId: Number(this.content.talkBackDeviceId),
          AudioDomId: 'html_audio_remote',
          Force: false,
          onDisconnected: disconnectedCallback,
          OnStop: stopCallback
        })
        .then(res => {
          this.TaskCode = res.TaskCode;
          this.isShowCountDown = true;
          this.$toast('现场通话启动成功');
        })
        .catch(e => {
          this.type = '';
          if (e.code == 2006) {
            this.$toast('设备不在线');
          } else if (e.code == 3551) {
            this.$toast('设备忙线中');
          } else {
            this.$toast('现场通话启动失败');
          }
        });
    },

    // 关闭语音对讲
    async voiceIntercomEnd() {
      this.type = '';
      this.$toast('现场通话关闭中！');
      try {
        let rsp = await this.sdk.audioSpeakStop({
          TaskCode: this.TaskCode
        });
        this.TaskCode = '';
        this.isShowCountDown = false;
        this.$toast('现场通话关闭成功！');
      } catch (error) {
        this.$toast('现场通话关闭失败！');
      }
    },

    // 计时器结束后关闭相应的对讲相关功能
    countDownFinish() {
      let _this = this;
      // 判断当前正在执行的操作
      let obj = {
        '2': async () => {
          await _this.shoutEnd();
        },
        '3': async () => {
          await _this.listenForEnd();
        },
        '4': async () => {
          await _this.voiceIntercomEnd();
        }
      };
      obj[_this.type]();
    },

    // 关闭当前所有的播报任务
    async closeAllTask() {
      let _this = this;

      let res = await axios.get(constant.baseUrl + 'student-consumer/api/voice/stopBroadcast', {
        // 线上地址
        // axios.get('http://192.168.10.135:8888/student-consumer/api/school/getSchoolInfo', {
        params: {
          id: _this.content.talkBackDeviceId
        },
        headers: {
          Authorization: _this.token
        }
      });
    },

    // 删除触发人
    delTriggerPerson(data) {
      let _this = this;

      this.$dialog
        .confirm({
          title: '温馨提示',
          message: `是否删除该触发人？`,
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              // 执行删除
              axios
                .post(
                  constant.baseUrl + 'student-consumer/api/warningUser/delWarningUser',
                  // axios.post('http://192.168.10.135:8888/student-consumer/api/warningUser/delWarningUser',

                  {
                    id: data.id
                  },
                  {
                    headers: {
                      Authorization: _this.token
                    }
                  }
                )
                .then(res => {
                  let data = res.data;

                  if (data.code == 200) {
                    _this.$toast('删除成功');
                    // 重新获取报警详情
                    _this.getAlarmDetail();
                    done();
                  } else if (data.code == 401) {
                    _this.$toast('登录过期，请重新登录');
                    setTimeout(() => {
                      wx.miniProgram.navigateTo({ url: '/pages/login/login' });
                    }, 1500);
                  }
                });
            } else {
              // 取消立即关闭弹窗
              done();
            }
          }
        })
        .then(() => {
          // 重新获取当前的报警详情
        });
    },

    // 关闭目标设备下的所有的播放任务
    handleChoiceAlarmType(type) {},

    sdkLog(level) {
      let fun = null;
      switch (level) {
        case 2:
          fun = console.error;
          break;
        case 3:
          fun = console.warn;
          break;
        case 4:
          fun = console.info;
          break;
        default:
          fun = console.log;
          break;
          break;
      }
      fun && fun('[SDK]', ...arguments);
    },

    // 打开触发人弹窗
    openAddTriggerPerson() {
      this.showTriggerPopup = true;
    },

    // 添加触发人
    addTriggerPerson() {
      if (!this.currentPerson) {
        this.$toast('请选择人员');
        return;
      }

      if (!this.currentBehaviorKind) {
        this.$toast('请选择行为分类');
        return;
      }

      // 获取当前选中的触发人的信息
      let person = this.triggerPersonList.find(item => item.id == this.currentPerson);

      let _this = this;

      let params = {
        addType: 1,
        avatar: person.avatar,
        isEmphasis: person.isEmphasis,
        name: person.name,
        orgName: person.deptName,
        personBehaviorType: this.currentBehaviorKind,
        personType: person.personType,
        userId: person.id,
        warningId: this.content.id,
        warningLocation: this.content.location,
        warningType: this.content.type
      };

      axios
        .post(
          constant.baseUrl + 'student-consumer/api/warningUser/saveWarningUser',
          // axios.post('http://192.168.10.135:8888/student-consumer/api/warningUser/saveWarningUser',

          params,
          {
            headers: {
              Authorization: _this.token
            }
          }
        )
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            _this.$toast('添加成功');
            this.handleClickCloseTriggerPopup();
            // 重新获取报警详情
            _this.getAlarmDetail();
          } else if (data.code == 401) {
            _this.$toast('登录过期，请重新登录');
            setTimeout(() => {
              wx.miniProgram.navigateTo({ url: '/pages/login/login' });
            }, 1500);
          } else {
            _this.$toast('添加失败');
          }
        });
    },

    // 预览图片
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl]
        // closeOnPopstate: true,
      });
    },
    previewImg2(index, list) {
      let tempList = list.map(item => {
        return item.tempFilePath;
      });
      ImagePreview({
        images: tempList,
        startPosition: index
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  background-color: #f9f9f9;
  height: 100%;
  display: flex;
  flex-direction: column;
  .detail_content {
    flex: 1;
    overflow: auto;
    padding: 0.8rem 0.625rem;
    .detail_top {
      padding: 0.75rem;
      background-color: #fff;
      border-radius: 0.5rem;
      margin-bottom: 0.625rem;
      position: relative;
      .top_title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 0.89rem;
        position: relative;
        color: #333333;
        padding-left: 0.5rem;
        line-height: 1;
        &::before {
          content: '';
          position: absolute;
          border-radius: 0.11rem 0.11rem 0.11rem 0.11rem;
          width: 0.22rem;
          height: 0.89rem;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          background: #0065e1;
        }
      }

      .top_img_video {
        height: 11.125rem;
        border: 1px solid #e5e5e5;
        position: relative;
        border-radius: 0.5rem;
        .alarm_keyword {
          position: absolute;
          top: 1rem;
          left: 0;
          right: 0;
          color: #fff;
          font-size: 0.875rem;
          text-align: center;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.5rem;
        }

        .video_div {
          width: 100%;
          height: 100%;
          border-radius: 0.5rem;
        }
      }

      .top_Countdown {
        font-size: 0.625rem;
        text-align: center;
        height: 1.11rem;

        // background-color: pink;
        img {
          display: inline-block;
          width: 0.425rem;
          margin-right: 0.3125rem;
          height: 0.4688rem;
        }

        .van-count-down {
          display: inline-block;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
          font-weight: normal;
          font-size: 0.625rem;
          height: 0.875rem;
          color: #333333;
          line-height: 0.875rem;
        }
      }

      // 操作分类
      .top_type {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 1.33rem;

        .top_type_item {
          line-height: 1;
          min-width: 5rem;
          // height: 3.75rem;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
          font-weight: normal;
          font-size: 0.86rem;
          color: #0065e1;
          padding: 0.5rem 0;
          margin-right: 1rem;
          border-radius: 0.25rem;
          display: flex;
          // flex-direction: column;
          align-items: center;
          justify-content: center;
          border: 0.0625rem solid #0065e1;

          img {
            height: 0.77rem;
          }
          &:nth-last-child {
            margin-right: 0;
          }
        }


        .item_active {
          border: none;
          background: #0065e1;
          color: #fff;
        }
      }

      .top_info {
        .top_info_item {
          display: flex;
          margin-bottom: 0.3125rem;

          .item_label {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 0.78rem;
            color: #999;
          }

          .item_info {
            margin-left: 0.89rem;
            flex: 1;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 0.78rem;
            color: #1a1a1a;
          }
        }
        .top_info_item + .top_info_item {
          margin-top: 1.11rem;
        }
      }
    }

    .detail_center {
      padding: 0.75rem;
      background-color: #fff;
      border-radius: 0.5rem;
      margin-bottom: 0.625rem;

      .center_title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 0.89rem;
        color: #333333;
        position: relative;
        padding-left: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 1;
        &::before {
          content: '';
          position: absolute;
          border-radius: 0.11rem 0.11rem 0.11rem 0.11rem;
          width: 0.22rem;
          height: 0.89rem;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          background: #0065e1;
        }

        .center_add {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 0.78rem;
          color: #0065e1;
          display: flex;
          align-items: center;

          img {
            width: 0.75rem;
            height: 0.75rem;
            margin-right: 0.1875rem;
          }
        }
      }

      .center_list {
        margin-top: 0.625rem;

        .center_item {
          display: flex;
          align-items: center;
          margin-bottom: 0.625rem;

          &:last-child {
            margin-bottom: 0;
          }

          .item_avatar {
            width: 3rem;
            height: 3.75rem;
          }

          .item_info {
            flex: 1;
            display: flex;
            margin-left: 0.5rem;
            flex-direction: column;
            justify-content: space-between;
            height: 2.6rem;

            span {
              font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular;
              font-weight: normal;
              font-size: 0.78rem;
              color: #1a1a1a;
              line-height: 1rem;
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
            }
            .item_type {
              color: #999;
              font-size: 0.75rem;
            }
          }

          .item_del {
            width: 1.125rem;
          }
        }
      }
    }

    .detail_bottom {
      padding: 0.75rem;
      background-color: #fff;
      padding-bottom: 1.25rem;

      .bottom_title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 1rem;
        padding-left: 0.5rem;
        position: relative;
        color: #333333;

        &::before {
          content: '';
          position: absolute;
          // top: 0;
          // bottom: 0;
          height: 0.875rem;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          border: 0.0625rem solid #37a5da;
        }
      }

      .bottom_info {
        margin-top: 0.625rem;
        margin-left: 0.625rem;
        display: flex;
        align-items: center;

        .info_label {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 0.875rem;
          color: #666666;
        }

        .info_detail {
          flex: 1;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 0.875rem;
          color: #333333;
        }

        .info_btns {
          display: flex;

          .btns_item {
            height: 1.75rem;
            width: 3.75rem;
            box-sizing: border-box;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 0.75rem;
            margin-right: 0.625rem;
            color: #fff;
            text-align: center;
            // padding: 0 1rem;
            line-height: 1.75rem;
            border-radius: 0.3125rem;
            position: relative;
            span {
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .btn_border {
            border: 0.1875rem solid #37a5da;
          }
        }

        .info_textArea {
          flex: 1;
          background-color: #666;

          .van-cell {
            padding: 0;
            padding: 0.125rem 0.5rem;
            background-color: #f5f3f6;
            margin: 0;
            height: 3.9375rem;
          }
        }
      }

      .bottom_test {
        align-items: normal;
      }
    }

    .access_btn_con {
      margin-top: 1.5rem;
      // margin-bottom: 1.125rem;
      text-align: center;

      .access_btn {
        height: 2.5rem;
        border-radius: 1.5625rem;
        width: 11.875rem;
        margin: auto;
      }
    }
  }
  .detail_operation {
    padding: 0.6rem;
    background-color: #fff;
    display: flex;
    .bottom-button {
      background-color: #f1f2f6;
      display: inline-block;
      border-radius: 0.22rem;
      font-size: 0.78rem;
      padding: 0.75rem 0;
      flex: 1;
      text-align: center;
      margin: 0 0.5rem;
    }
    .button-disabled {
      opacity: 0.5;
    }
    .button-primary {
      background-color: #0065e1;
      color: #fff;
    }
    .button-warning {
      background-color: #fea301;
      color: #fff;
    }
    .button-danger {
      background-color: #f16f6d;
      color: #fff;
    }
    .button-info {
      background-color: #8f939e;
      color: #fff;
    }
  }

  .popup {
    padding: 0 0.625rem;
    display: flex;
    flex-direction: column;

    .popup_title {
      padding: 0.625rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .popup_form {
      flex: 1;
      margin-top: 0.625rem;

      .form_name {
        margin-bottom: 0.625rem;
        display: flex;
        align-items: center;

        .name_text {
          font-size: 0.875rem;
        }

        .name_select {
          flex: 1;

          .el-select-dropdown__wrap {
            max-height: 50px;
          }
        }
      }

      .form_kind {
        display: flex;
        align-items: center;

        .name_text {
          font-size: 0.875rem;
        }

        .name_select {
          flex: 1;

          .select_option {
            max-height: 6.25rem;
          }
        }
      }
    }

    .popup_btn {
      display: flex;
      padding: 1rem 0;
      justify-content: space-between;
    }

    .title_text {
      font-size: 1rem;
    }

    .title_img {
    }
  }
}
.pop-select-list {
  overflow: hidden;
  padding: 1rem 0;
  .pop-select-list-inner {
    height: 100%;
    overflow: auto;
    .pop-select-item {
      text-align: center;
      padding: 1rem 0;
      font-size: 1.1rem;
    }
    .pop-select-item + .pop-select-item {
      border-top: 1px solid #ebedf0;
    }
  }
}
</style>
